/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterYearData
 */
export interface FilterYearData {
    /**
     * 
     * @type {number}
     * @memberof FilterYearData
     */
    year?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    budget?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    clientId?: string;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    saleDateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    saleDateTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    invoiced?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    invoiceDateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    invoiceDateTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    withPositions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    yearType?: string;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    rangeMonthFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterYearData
     */
    rangeMonthTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    salesInvoices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    salesInvoicesCopies?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    purchaseInvoices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    contracts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterYearData
     */
    projectAttachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterYearData
     */
    attachmentsTypesIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    client?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterYearData
     */
    surveyId?: string;
}

/**
 * Check if a given object implements the FilterYearData interface.
 */
export function instanceOfFilterYearData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FilterYearDataFromJSON(json: any): FilterYearData {
    return FilterYearDataFromJSONTyped(json, false);
}

export function FilterYearDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterYearData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': !exists(json, 'year') ? undefined : json['year'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'teamId': !exists(json, 'teamId') ? undefined : json['teamId'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'budget': !exists(json, 'budget') ? undefined : json['budget'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'saleDateFrom': !exists(json, 'saleDateFrom') ? undefined : (new Date(json['saleDateFrom'])),
        'saleDateTo': !exists(json, 'saleDateTo') ? undefined : (new Date(json['saleDateTo'])),
        'invoiced': !exists(json, 'invoiced') ? undefined : json['invoiced'],
        'invoiceDateFrom': !exists(json, 'invoiceDateFrom') ? undefined : (new Date(json['invoiceDateFrom'])),
        'invoiceDateTo': !exists(json, 'invoiceDateTo') ? undefined : (new Date(json['invoiceDateTo'])),
        'withPositions': !exists(json, 'withPositions') ? undefined : json['withPositions'],
        'yearType': !exists(json, 'yearType') ? undefined : json['yearType'],
        'rangeMonthFrom': !exists(json, 'rangeMonthFrom') ? undefined : (new Date(json['rangeMonthFrom'])),
        'rangeMonthTo': !exists(json, 'rangeMonthTo') ? undefined : (new Date(json['rangeMonthTo'])),
        'salesInvoices': !exists(json, 'salesInvoices') ? undefined : json['salesInvoices'],
        'salesInvoicesCopies': !exists(json, 'salesInvoicesCopies') ? undefined : json['salesInvoicesCopies'],
        'purchaseInvoices': !exists(json, 'purchaseInvoices') ? undefined : json['purchaseInvoices'],
        'contracts': !exists(json, 'contracts') ? undefined : json['contracts'],
        'projectAttachments': !exists(json, 'projectAttachments') ? undefined : json['projectAttachments'],
        'project': !exists(json, 'project') ? undefined : json['project'],
        'attachmentsTypesIds': !exists(json, 'attachmentsTypesIds') ? undefined : json['attachmentsTypesIds'],
        'client': !exists(json, 'client') ? undefined : json['client'],
        'surveyId': !exists(json, 'surveyId') ? undefined : json['surveyId'],
    };
}

export function FilterYearDataToJSON(value?: FilterYearData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'companyId': value.companyId,
        'teamId': value.teamId,
        'type': value.type,
        'status': value.status,
        'budget': value.budget,
        'currency': value.currency,
        'clientId': value.clientId,
        'saleDateFrom': value.saleDateFrom === undefined ? undefined : (value.saleDateFrom.toISOString()),
        'saleDateTo': value.saleDateTo === undefined ? undefined : (value.saleDateTo.toISOString()),
        'invoiced': value.invoiced,
        'invoiceDateFrom': value.invoiceDateFrom === undefined ? undefined : (value.invoiceDateFrom.toISOString()),
        'invoiceDateTo': value.invoiceDateTo === undefined ? undefined : (value.invoiceDateTo.toISOString()),
        'withPositions': value.withPositions,
        'yearType': value.yearType,
        'rangeMonthFrom': value.rangeMonthFrom === undefined ? undefined : (value.rangeMonthFrom.toISOString()),
        'rangeMonthTo': value.rangeMonthTo === undefined ? undefined : (value.rangeMonthTo.toISOString()),
        'salesInvoices': value.salesInvoices,
        'salesInvoicesCopies': value.salesInvoicesCopies,
        'purchaseInvoices': value.purchaseInvoices,
        'contracts': value.contracts,
        'projectAttachments': value.projectAttachments,
        'project': value.project,
        'attachmentsTypesIds': value.attachmentsTypesIds,
        'client': value.client,
        'surveyId': value.surveyId,
    };
}

